import { FC, useEffect, useRef, useState } from "react";
import { getFormatedDate } from "../../../../utils/dataParser";
import Cross from "../../../UI/Icons/Cross";
import Play from "../../../UI/Icons/Play";
import PopupModal from "../../../UI/Popup";

interface OnlineInterviewVideoPlayProps {
  showVideoModal: boolean;
  onClickClose: () => void;
  answer: any;
}

const OnlineInterviewVideoPlay: FC<OnlineInterviewVideoPlayProps> = ({
  showVideoModal,
  onClickClose,
  answer,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isEnded, setIsEnded] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const handleTogglePlayPause = () => {
    if (!videoRef.current) return;

    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  const handleVideoEnd = () => {
    setIsEnded(true);
    setIsPlaying(false);
  };

  const handleTimeUpdate = () => {
    if (videoRef.current) {
      setCurrentTime(videoRef.current.currentTime);
    }
  };

  const handleLoadedMetadata = () => {
    if (videoRef.current) {
      setDuration(videoRef.current.duration);
    }
  };

  const formatTime = (time: number): string => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const handleClose = () => {
    answer.answer_video_url = null;
    onClickClose();
  }

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }

    setIsPlaying(false);
    setIsEnded(false);
    setCurrentTime(0);
  }, [showVideoModal, videoRef]);

  return (
    <PopupModal
      visible={showVideoModal}
      showCloseBtn={false}
      customWidth={750}
    >
      <div className="position-absolute top-0 end-0 p-25 cursor-pointer" onClick={handleClose}>
        <Cross size={24} />
      </div>

      <div className="d-flex flex-column gap-3">
        <div className="fs-16 fw-700 text-black pr-15px">
          {answer?.interview_question?.question_text ?? ""}
        </div>
        <div className="fs-13 fw-400 text-black pr-15px">
          Uploaded: {getFormatedDate(answer?.created_datetime)}
        </div>
      </div>

      {answer?.answer_video_url ? (
        <div className="w-699px h-410px position-relative">
          <video
            width="699"
            height="410"
            className="object-fit-cover"
            ref={videoRef}
            onEnded={handleVideoEnd}
            onTimeUpdate={handleTimeUpdate}
            onLoadedMetadata={handleLoadedMetadata}
            onClick={handleTogglePlayPause}
          >
            <source src={answer.answer_video_url} type="video/mp4" />
          </video>

          {!isPlaying && (
            <div
              className="position-absolute top-50 start-50 translate-middle cursor-pointer"
              onClick={handleTogglePlayPause}
            >
              <Play />
            </div>
          )}

          <div className="position-absolute bottom-0 end-0 p-2 text-white bg-dark bg-opacity-50 rounded">
            {formatTime(currentTime)} / {formatTime(duration)}
          </div>
        </div>
      ) : (
        ""
      )}
    </PopupModal>
  );
};

export default OnlineInterviewVideoPlay;